export const GET_ALL_TEAMS = "GET_ALL_TEAMS";
export const GET_ALL_TEAMS_FOR_CHAMPIONSHIP = "GET_ALL_TEAMS_FOR_CHAMPIONSHIP";
export const GET_TEAM_DATA = "GET_TEAM_DATA";
export const DELETE_TEAM = "DELETE_TEAM";
export const ADD_TEAM = "ADD_TEAM";
export const EDIT_TEAM = "EDIT_TEAM";

